export default __webpack_public_path__ + "static/travel-hero-bg-low-res-cb202894998d0e627a7137fba00afc56.jpg";